import { z } from 'zod';
export const signupSchema = z.object({
    email: z.string().email().max(254).transform((s) => s.toLowerCase().trim()),
    password: z.string().min(12).max(128),
    business_name: z.string().min(2).max(255).transform((s) => s.trim()),
    phone: z.string().min(10).max(20).regex(/^\+?[\d\s\-().]+$/, 'Phone must contain only digits, spaces, hyphens, and parentheses'),
    first_name: z.string().min(1).max(100).optional(),
    last_name: z.string().min(1).max(100).optional(),
});
export const verifyEmailSchema = z.object({
    token: z.string().min(32).max(128),
});
export const resendVerificationSchema = z.object({
    email: z.string().email().max(254).transform((s) => s.toLowerCase().trim()),
});
//# sourceMappingURL=signup.js.map